import * as React from 'react';
import { memo } from 'react';

const SvgCopyV2 = (props) => (React.createElement("svg", Object.assign({ width: "1em", height: "1em", viewBox: "0 0 17 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M11.195 10.5h3v-8h-8v3", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M11.195 5.5h-8v8h8v-8Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" })));
const Memo = memo(SvgCopyV2);

export { Memo as default };
